import { GET_VEHICALTYREPOSITION_REQUEST, GET_VEHICALTYREPOSITION_SUCCESS, GET_VEHICALTYREPOSITION_FAIL,
    CREATE_VEHICLETYPE_REQUEST, CREATE_VEHICLETYPE_SUCCESS, CREATE_VEHICLETYPE_FAIL,
    GET_VEHICLETYPE_REQUEST, GET_VEHICLETYPE_SUCCESS, GET_VEHICLETYPE_FAIL,
    UPDATE_VEHICLETYPE_REQUEST, UPDATE_VEHICLETYPE_SUCCESS, UPDATE_VEHICLETYPE_FAIL } from '../types/vehicleTypes'

function updateVehicleTypeReducer( state = { updateVehicleType: {} }, action) {
    switch (action.type) {
        case UPDATE_VEHICLETYPE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_VEHICLETYPE_SUCCESS: 
            return {
                ...state,
                updateVehicleType: action.payload,
                isLoading: false
            }
        case UPDATE_VEHICLETYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function getVehicleTypeReducer( state = { vehicleTypeList: [] }, action) {
    switch (action.type) {
        case GET_VEHICLETYPE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICLETYPE_SUCCESS: 
            return {
                ...state,
                vehicleTypeList: action.payload,
                isLoading: false
            }
        case GET_VEHICLETYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createVehicleTypeReducer( state = { createVehicleType: {} }, action) {
    switch (action.type) {
        case CREATE_VEHICLETYPE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_VEHICLETYPE_SUCCESS: 
            return {
                ...state,
                createVehicleType: action.payload,
                isLoading: false
            }
        case CREATE_VEHICLETYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function tyrePositionListReducer( state = { tyrePositionList: [] }, action) {
    switch (action.type) {
        case GET_VEHICALTYREPOSITION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICALTYREPOSITION_SUCCESS: 
            return {
                ...state,
                tyrePositionList: action.payload,
                isLoading: false
            }
        case GET_VEHICALTYREPOSITION_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateTyrePositionListReducer( state = { tyrePositionList: [] }, action) {
    switch (action.type) {
        case GET_VEHICALTYREPOSITION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICALTYREPOSITION_SUCCESS: 
            return {
                ...state,
                tyrePositionList: action.payload,
                isLoading: false
            }
        case GET_VEHICALTYREPOSITION_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}



export { tyrePositionListReducer, createVehicleTypeReducer, getVehicleTypeReducer, updateVehicleTypeReducer }